import { render, staticRenderFns } from "./UserRelation.vue?vue&type=template&id=60425c87&scoped=true&"
import script from "./UserRelation.vue?vue&type=script&lang=js&"
export * from "./UserRelation.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UserRelation.vue?vue&type=style&index=1&id=60425c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60425c87",
  null
  
)

export default component.exports